<template>
    <v-card class="my-2">
        <v-card-title>{{ message.role }}</v-card-title>
        <v-card-text>{{ message.full_text }}</v-card-text>
    </v-card>
</template>

<script>
    export default {
        components: {
        },
        props: {
            message: {
                required: true,
            }
        },
        data() {
            return {
            }
        },
        methods: { 
        }
    }
</script>